module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zk-switch",
    class: {
      'is-disabled': _vm.disabled, 'zk-switch--wide': _vm.hasText
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disabled),
      expression: "disabled"
    }],
    staticClass: "zk-switch__mask"
  }), _vm._v(" "), _c('input', {
    staticClass: "zk-switch__input",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "checkbox",
      "name": _vm.name,
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.value
    }
  }), _vm._v(" "), _c('span', {
    ref: "core",
    staticClass: "zk-switch__core",
    style: ({
      'width': _vm.coreWidth + 'px'
    }),
    on: {
      "click": _vm.handleMiscClick
    }
  }, [_c('span', {
    staticClass: "zk-switch__button",
    style: (_vm.buttonStyle)
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "label-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "zk-switch__label zk-switch__label--left",
    style: ({
      'width': _vm.coreWidth + 'px'
    }),
    on: {
      "click": _vm.handleMiscClick
    }
  }, [(_vm.onIconClass) ? _c('i', {
    class: [_vm.onIconClass]
  }) : _vm._e(), _vm._v(" "), (!_vm.onIconClass && _vm.onText) ? _c('span', [_vm._v(_vm._s(_vm.onText))]) : _vm._e()])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "label-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.value),
      expression: "!value"
    }],
    staticClass: "zk-switch__label zk-switch__label--right",
    style: ({
      'width': _vm.coreWidth + 'px'
    }),
    on: {
      "click": _vm.handleMiscClick
    }
  }, [(_vm.offIconClass) ? _c('i', {
    class: [_vm.offIconClass]
  }) : _vm._e(), _vm._v(" "), (!_vm.offIconClass && _vm.offText) ? _c('span', [_vm._v(_vm._s(_vm.offText))]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-1f3f4c82"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/switch/src/switch.vue
// module id = 240
// module chunks = 0